import { inject, Injectable } from '@angular/core';
import { ServicesService } from '../services/services.service';

@Injectable({
  providedIn: 'root',
})
export class PlatformEndpointService {
  readonly #service = inject(ServicesService);

  me() {
    return this.#service.platform('v1/me');
  }

  activateLicense() {
    return this.#service.platform('v1/license/activate');
  }

  refreshEditionUser() {
    return this.#service.edition('refresh-user');
  }
}
